// extracted by mini-css-extract-plugin
export default {"pageRoot":"FinancePage_pageRoot__jEt1j","pageContent":"FinancePage_pageContent__B3MZg"};